const EVENT_ID_ADDRESS_NAME = '@eventId';
const EVENT_ID_SAVE_DATE_ADDRESS_NAME = '@eventIdSaveDate';

export const saveEventId = (eventId) => {
    localStorage.setItem(EVENT_ID_ADDRESS_NAME, eventId);
    localStorage.setItem(EVENT_ID_SAVE_DATE_ADDRESS_NAME, new Date().getTime());
};

export const getEventId = () => {
    const eventId = localStorage.getItem(EVENT_ID_ADDRESS_NAME);
    if (!eventId) {
        return null;
    }

    const eventIdSaveDate = localStorage.getItem(EVENT_ID_SAVE_DATE_ADDRESS_NAME);
    if (isLessThanHoursApart(eventIdSaveDate, new Date().getTime(), 24)) {
        return eventId;
    }

    deleteEventId();
    return null;
};

export const deleteEventId = () => {
    localStorage.removeItem(EVENT_ID_ADDRESS_NAME);
    localStorage.removeItem(EVENT_ID_SAVE_DATE_ADDRESS_NAME);
};

const isLessThanHoursApart = (date1, date2, hours) => {
    const differenceInMilliseconds = Math.abs(date1 - date2);
    const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);
    return differenceInHours < hours;
};
